var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9187 25.4499C13.6709 25.4499 13.456 25.3615 13.274 25.1847C13.0913 25.0072 13 24.7981 13 24.5574C13 24.3166 13.0913 24.1079 13.274 23.9311C13.456 23.7536 13.6709 23.6648 13.9187 23.6648H14.7282V17.821C14.7282 16.6595 15.0929 15.6218 15.8223 14.7078C16.5509 13.7939 17.4913 13.1955 18.6435 12.9126V12.3169C18.6435 11.949 18.7747 11.6375 19.0372 11.3825C19.2997 11.1275 19.6206 11 20 11C20.3794 11 20.7003 11.1275 20.9628 11.3825C21.2253 11.6375 21.3565 11.949 21.3565 12.3169V12.9126C22.5087 13.1955 23.4456 13.7939 24.1672 14.7078C24.8889 15.6218 25.2497 16.6595 25.2497 17.821V23.6648H26.0813C26.3291 23.6648 26.544 23.7536 26.726 23.9311C26.9087 24.1079 27 24.3166 27 24.5574C27 24.7981 26.9087 25.0072 26.726 25.1847C26.544 25.3615 26.3291 25.4499 26.0813 25.4499H13.9187ZM20 28C19.5044 28 19.0886 27.8371 18.7527 27.5114C18.4174 27.1857 18.2497 26.7821 18.2497 26.3006H21.7503C21.7503 26.7821 21.5826 27.1857 21.2473 27.5114C20.9114 27.8371 20.4956 28 20 28ZM16.5656 23.6648H23.4123V17.821C23.4123 16.9145 23.084 16.1356 22.4275 15.4841C21.7716 14.832 20.9625 14.5059 20 14.5059C19.0669 14.5059 18.2613 14.832 17.583 15.4841C16.9048 16.1356 16.5656 16.9145 16.5656 17.821V23.6648Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notif_icon.ddf663d782a745afca55f83af226a1ac.svg";
export { ForwardRef as ReactComponent };